import API_URLS from "@constants/apiUrls";
import { api } from "services/customBaseQuery";


export const creditReportsAPI = api.injectEndpoints({
  endpoints: (build) => ({
    fetchFulfilmentHistory: build.query<any, any>({
      query: (params) => {
        const queryString = params ? `?${new URLSearchParams(params).toString()}` : "";
        return {
          url: `${API_URLS.FULFILMENTS}${queryString}`,
          method: "GET",
          credentials: "include",
        };
      },
      keepUnusedDataFor: 0,
    }),
    fetchCreditOrders: build.query<any, any>({
      query: (params) => {
        const queryString = params ? `?${new URLSearchParams(params).toString()}` : "";
        return {
          url: `${API_URLS.CREDIT_ORDERS}${queryString}`,
          method: "GET",
          credentials: "include",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useFetchFulfilmentHistoryQuery, useFetchCreditOrdersQuery } = creditReportsAPI;